var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIconTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.55957,
    width: 20,
    height: 20,
    fill: "url(#pattern0_1098_20646)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1098_20646",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1098_20646",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1098_20646",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABe0lEQVR4nO1YSU7EMBDMiTcM8INckypH0fAClu8kD2AJj2IYibfAHSYXTkEtEsFhMowtO3FEl+SbU93lbrejShKFQqGIDnmeXwPYkGxJdp5WK5wAroImD+DeY9J7F4C7IMkbY276IJ8AqizLTn1xC5dwCncvwn8l+rYR8so7+U+Mqo/x5J186HkAqyQQhLuP8eGdfOhR78RTxaElMcltgEveAniWSRhcAICXqKYVJ2qhQyjL8sx5WsUgYM+02iQLFbCynlYxCXDKRwV4BrUCM4NLqUCapicAHkm+HXjUXkk2sjc6ASQbixe6iU4Avk+3y/O8HNtjjFkPlYixAt0xcf/cpwIcQa1AJJfYGLMe20PyIuZL3FiM0YcoHzKSzVCJxT1ki/+VGIMKmBv8dy0EYCcf+DR1XVEUxXk/fd5dzN06aHbH5VJbm8Bi5/2218VkSuYxturB2CJ5aUUgdl5Iu9By3Tqdgth5UrrhTky5AOwktvXJKxQKRTIHvgAaZjmBrDd8dgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconTransactions);
export default __webpack_public_path__ + "static/media/nav-icon-transactions.6ff443499db42a4e9b8992ce12db43fc.svg";
export { ForwardRef as ReactComponent };